import { memo } from "react";
import PropTypes from "prop-types";

import TextField from "@material-ui/core/TextField";
import makeStyles from "@material-ui/core/styles/makeStyles";

import inputStyles from "common/components/form-fields/input/input.styles";
import areEqual from "common/components/form-fields/utils/are-equal";

const useStyles = makeStyles(inputStyles);

function InputField({
  name,
  touched,
  error,
  inputPropsOptions,
  onBlur,
  onChange,
  value,
  variant,
  label,
  margin,
  fullWidth,
  required,
  className,
  multiline,
  rows,
  placeholder,
  type,
  disabled,
}) {
  const classes = useStyles();

  return (
    <TextField
      id={name}
      error={touched && Boolean(error)}
      helperText={touched ? error : ""}
      InputProps={{
        classes: {
          input: classes.input,
        },
      }}
      // eslint-disable-next-line react/jsx-no-duplicate-props
      inputProps={inputPropsOptions}
      name={name}
      onBlur={onBlur}
      onChange={onChange}
      value={value}
      variant={variant}
      label={label}
      margin={margin}
      fullWidth={fullWidth}
      required={required}
      className={className}
      multiline={multiline}
      rows={rows}
      placeholder={placeholder}
      type={type}
      disabled={disabled}
    />
  );
}

InputField.propTypes = {
  name: PropTypes.string.isRequired,
  touched: PropTypes.bool.isRequired,
  error: PropTypes.string,
  inputPropsOptions: PropTypes.instanceOf(Object).isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  variant: PropTypes.oneOf(["standard", "outlined", "filled"]).isRequired,
  label: PropTypes.string.isRequired,
  margin: PropTypes.oneOf(["none", "dense", "normal"]).isRequired,
  fullWidth: PropTypes.bool,
  required: PropTypes.bool,
  className: PropTypes.string,
  multiline: PropTypes.bool,
  rows: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.oneOf(["text", "number"]),
  disabled: PropTypes.bool,
};

InputField.defaultProps = {
  error: undefined,
  fullWidth: false,
  required: false,
  className: "",
  multiline: false,
  rows: "",
  placeholder: "",
  type: "text",
  disabled: false,
};

export default memo(InputField, areEqual);
